import NumOfBetsController from '../../controllers/autospin/NumOfBetsController';
import AutoSpinController from '../../controllers/autospin/AutoSpinController';
import AutoSpinCheckBoxController from '../../controllers/autospin/AutoSpinCheckBoxController';
import { COMPONENTS } from '../../lib/constants';
import MainGridController from '../../controllers/grid/MainGridController';
import { AutoSpinViewGrid } from './AutoSpinViewGrid';
import CloseController from '../../controllers/CloseController';
export const AutoSpinView = {
	name: COMPONENTS.AUTO_SPIN,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: AutoSpinController,
			name: 'AutoSpinController',
			config: {
				item: 'autospin_btn',
				val: 'autospin_btn',
				holder: 'auto_spin_bg'
			}
		},
		{
			Controller: CloseController,
			name: 'CloseController',
			config: {
				closeBtn: 'close',
				remove: true
			}
		},
		{
			Controller: AutoSpinCheckBoxController,
			name: 'AutoSpinController',
			config: {
				item: 'auto_spin_bg',
				val: 'auto_spin_bg'
			}
		},
		{
			Controller: NumOfBetsController,
			name: 'NumOfBetsController',
			config: {
				item: 'numOfBets',
				numbers: [
					{
						item: 'num_10',
						position: { x: 20, y: 0 },
						text: '10',
						val: '10'
					},
					{
						item: 'num_50',
						position: { x: 105, y: 0 },
						text: '50',
						val: '50'
					},
					{
						item: 'num_100',
						position: { x: 190, y: 0 },
						text: '100',
						val: '100'
					},
					{
						item: 'num_500',
						position: { x: 275, y: 0 },
						text: '500',
						val: '500'
					},
					{
						item: 'num_1000',
						position: { x: 360, y: 0 },
						text: '1000',
						val: '1000'
					},
					{
						item: 'num_0',
						position: { x: 445, y: 0 },
						text: '',
						val: ''
					}
				],
				colors: {
					active: '#7BA21C',
					inactive: '#7571CA'
				},
				position: { x: 0, y: 0 },
				img: {
					active: 'infinity_symbol',
					inactive: 'infinity_symbol'
				}
			}
		},
		{
			Controller: MainGridController,
			name: 'MainGridController',
			config: AutoSpinViewGrid
		}
	],
	components: [
		{
			name: 'auto_spin_bg',
			type: 'Sprite',
			components: [
				{
					name: 'auto_spin_bg1',
					type: 'Sprite',
					img: 'dialog_main_bg'
				},
				{
					name: 'bg-border',
					type: 'Sprite',
					img: 'sm_modal_frame',
					position: { x: -7, y: 0 }
				},
				{
					name: 'auto_spin_title',
					type: 'Text',
					text: 'AUTOSPIN_HEADER',
					position: { x: 573 / 2, y: 30 },
					anchor: {
						x: 0.5,
						y: 0
					}
				},
				{
					name: 'auto_spin_anim_cb',
					type: 'Button',
					components: [
						{
							name: 'auto_spin_anim_checkbox',
							type: 'SwitchButton',
							bg: 'checkbox_inactive',
							fg: 'checkbox_active',
							position: { x: 55, y: 117 }
						},
						{
							name: 'auto_spin_anim_text',
							type: 'SwitchButton',
							text: 'AUTOSPIN_ANIM_TEXT',
							position: { x: 85, y: 110 }
						}
					]
				},
				{
					name: 'auto_spin_fast_cb',
					type: 'Sprite',
					components: [
						{
							name: 'auto_spin_fast_checkbox',
							type: 'SwitchButton',
							bg: 'checkbox_inactive',
							fg: 'checkbox_active',
							position: { x: 365, y: 117 }
						},
						{
							name: 'auto_spin_fast_text',
							type: 'SwitchButton',
							text: 'AUTOSPIN_FAST_TEXT',
							position: { x: 395, y: 110 }
						}
					]
				},
				{
					name: 'auto_number_of_spins_text',
					type: 'Text',
					text: 'AUTOSPIN_NUMBEROFSPIN_TEXT',
					position: { x: 573 / 2, y: 175 },
					anchor: {
						x: 0.5,
						y: 0
					}
				},
				{
					name: 'numOfBets',
					position: { x: 20, y: 245 },
					type: 'Sprite',
					components: [
						{
							name: 'num_10',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							anchor: {
								x: 0.5,
								y: 0.5
							},
							position: { x: 0, y: 0 }
						},
						{
							name: 'num_50',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							position: { x: 0, y: 0 },
							anchor: {
								x: 0.5,
								y: 0.5
							}
						},
						{
							name: 'num_100',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							position: { x: 0, y: 0 },
							anchor: {
								x: 0.5,
								y: 0.5
							}
						},
						{
							name: 'num_500',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							position: { x: 0, y: 0 },
							anchor: {
								x: 0.5,
								y: 0.5
							}
						},
						{
							name: 'num_1000',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							position: { x: 0, y: 0 },
							anchor: {
								x: 0.5,
								y: 0.5
							}
						},
						{
							name: 'num_0',
							type: 'SwitchButton',
							bg: 'selected_amount_bg',
							fg: 'unselected_amount_bg',
							bgText: 'NUMBER_OF_BETS',
							fgText: 'NUMBER_OF_BETS_SELECTED',
							anchor: {
								x: 0.5,
								y: 0.5
							},
							position: { x: 0, y: 0 }
						}
					]
				},
				{
					name: 'close',
					type: 'ActionButton',
					bg: 'dialog_no_btn',
					position: { x: 205, y: 395 }
				},
				{
					name: 'autospin_btn_holder',
					type: 'Sprite',
					components: [
						{
							name: 'autospin_btn',
							type: 'ActionButton',
							bg: 'dialog_yes_btn',
							position: { x: 365, y: 395 }
						}
					]
				}
			]
		}
	]
};
